import sparkHomepage from "../../../../src/images/util/spark_homepage.png";
import sparkMain from "../../../../src/images/util/spark_main.png";
import sparkAddAccount1 from "../../../../src/images/util/spark_add_account1.png";
import sparkAddAccount2 from "../../../../src/images/util/spark_add_account2.png";
import sparkNaver2FA1 from "../../../../src/images/util/spark_naver_2FA1.png";
import sparkNaver2FA2 from "../../../../src/images/util/spark_naver_2FA2.png";
import sparkChangeMailApp from "../../../../src/images/util/spark_change_mail_app.png";
import sparkAppStore from "../../../../src/images/util/spark_appstore.png";
import sparkAppAddAccount from "../../../../src/images/util/spark_app_add_account.png";
import sparkAppVerifyAccount from "../../../../src/images/util/spark_app_verify_account.png";
import sparkAppAccountList from "../../../../src/images/util/spark_app_account_list.png";
import sparkAppMailList from "../../../../src/images/util/spark_app_mail_list.png";
import * as React from 'react';
export default {
  sparkHomepage,
  sparkMain,
  sparkAddAccount1,
  sparkAddAccount2,
  sparkNaver2FA1,
  sparkNaver2FA2,
  sparkChangeMailApp,
  sparkAppStore,
  sparkAppAddAccount,
  sparkAppVerifyAccount,
  sparkAppAccountList,
  sparkAppMailList,
  React
};